import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { UnenrolledDeviceEffects } from './unenrolled-device.effects';
import { unenrolledDeviceReducer } from './unenrolled-device.reducer';

export const provideUnenrolledDeviceStore = () => [
  provideState('unenrolled-device', unenrolledDeviceReducer),
  provideEffects([UnenrolledDeviceEffects]),
];
